import { FC, useState } from "react";
import { Chip, IconButton, Typography } from "@material-ui/core";
import { Delete } from "@material-ui/icons";
import { MainTableCell } from "../../shared/Style/Style";
import { BundlesListItem } from "../styles";
import { ModelBundle } from "../../../generated/graphql";
import { experiments } from "./SelectModelType";
import { MobileAppDeleteModal } from "../../MobileAppModal/MobileAppDeleteModal/MobileAppDeleteModal";

interface BundlesStorageListProps {
  models: Partial<ModelBundle>[];
  onOpenModal?: (id: string) => void;
}

export const BundlesStorageList: FC<BundlesStorageListProps> = ({
  models,
  onOpenModal,
}) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState({
    isOpen: false,
    model: null,
  });

  return (
    <>
      {models?.map((model) => (
        <BundlesListItem key={model.id} onClick={() => onOpenModal(model.id)}>
          <MainTableCell>{model.name}</MainTableCell>
          <MainTableCell>{model.number}</MainTableCell>
          <MainTableCell>
            {experiments.find((item) => item.type === model.contentType)?.text}
          </MainTableCell>
          <MainTableCell>
            {model.tags?.map((tag) => (
              <Chip
                key={tag.id}
                label={tag.name}
                size="small"
                style={{ marginRight: 4, marginBottom: 4 }}
              />
            ))}
          </MainTableCell>
          <MainTableCell>
            <Typography color="error">{model.isDraft && "Чернетка"}</Typography>
          </MainTableCell>
          <MainTableCell>
            {new Date(model.createdDate).toLocaleDateString("uk-UA")}
          </MainTableCell>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setIsDeleteModalOpen({ isOpen: true, model });
            }}
          >
            <Delete color="error" />
          </IconButton>
        </BundlesListItem>
      ))}
      {isDeleteModalOpen.isOpen && (
        <MobileAppDeleteModal
          open={isDeleteModalOpen.isOpen}
          close={() => setIsDeleteModalOpen({ isOpen: false, model: null })}
          item={isDeleteModalOpen.model}
        />
      )}
    </>
  );
};
